import { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { Store, useAppDispatch } from 'src/redux/Store';
import { getUserCreditCardAction } from 'src/redux/actions/paymentInfoAction';
import { CreditCardModel } from 'src/models/CreditCardModel';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import { makeStyles } from '@material-ui/core/styles';
import { ENTITIES } from 'src/models/QuerybuilderModel';
import { openDialog } from 'src/redux/actions/dialogActions';
import { DIALOGS } from 'src/models/DialogModel';
import { setCurrentEntity } from 'src/redux/actions/currentEntityActions';
import { openModal } from 'src/redux/actions/modalActions';
import { MODALS } from 'src/models/ModalModel';
import PaymentInfo from 'src/components/UI/PaymentInfo';

const useStyles = makeStyles((theme) => ({
  deletePaymentInfo: {
    color: theme.palette.action.active,
    margin: '0 4px',
    '&:hover': {
      color: theme.palette.primary.main,
      cursor: 'pointer',
    },
  },
}));

const UserCreditCardDisplayer = () => {
  const dispatch = useAppDispatch();
  const classes = useStyles();

  const creditCards = useSelector(
    (state: Store) => {
      if (!!state.userCreditCards) {
        return state.userCreditCards as CreditCardModel[];
      }
      return [] as CreditCardModel[];
    },
  );

  useEffect(() => {
    dispatch(
      getUserCreditCardAction(),
    );
  }, []);

  const handleDeleteCreditCard = (id: number) => {
    dispatch(setCurrentEntity({ entity: ENTITIES.creditCards, id }));
    dispatch(openDialog({ dialog: DIALOGS.deleteCreditCard }));
  };

  const handleEditCreditCard = (creditCard: CreditCardModel) => {
    dispatch(openModal({
      modal: MODALS.editUserCreditCard,
      payload: {
        creditCard,
      },
    }));
  };

  const displayCreditCard = () => creditCards.map((card:CreditCardModel, index: number) => (
    <PaymentInfo key={`credit-card-${index}`}>
      <span>{card.masked_card_number} exp: {card.expiration_data}</span>
      <DeleteIcon
        className={classes.deletePaymentInfo}
        fontSize="small"
        onClick={() => handleDeleteCreditCard(card.id)} />
      <EditIcon
        className={classes.deletePaymentInfo}
        fontSize="small"
        onClick={() => handleEditCreditCard(card)} />
    </PaymentInfo>
  ));

  return (
    <>{displayCreditCard()}</>
  );
};

export default UserCreditCardDisplayer;
